import { GridCell } from '@mobi/component-library/Common/Grid'
import { Money } from '@core/Components/Text/Money'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { colors, font, radius } from '@mobi/component-library/Theme/Common'

interface BonusBetListItemButtonProps {
  selected: boolean
  disabled?: boolean
  isBonusCash: boolean
}

export const BonusBetListItemButtonStyled = styled('div')<BonusBetListItemButtonProps>(
  {
    padding: '0.9rem 1rem',
    marginBottom: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.85rem',

    '&.split-tokens': {
      padding: '0.65rem 1rem',
    },
  },

  ({ selected, disabled, isBonusCash }) => ({
    background:
      selected && !disabled
        ? isBonusCash
          ? hexColors.mariner
          : colors.success[600]
        : hexColors.white,
    color: selected ? hexColors.white : hexColors.black,
    border: `0.1rem solid ${hexColors.veryLightGrey}`,
  }),

  ({ disabled }) =>
    disabled && {
      opacity: 0.3,
    }
)

export const BonusBetLabelStyled = styled(GridCell)<{ isBonusCash?: boolean; selected?: boolean }>(
  {
    fontSize: '1.2rem',
    lineHeight: 'normal',
    fontWeight: 'bold',
    alignItems: 'center',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: '0.25rem',
  },
  ({ isBonusCash, selected }) => ({
    color: isBonusCash ? (selected ? hexColors.white : hexColors.mariner) : undefined,
  })
)

export const ExpiryLabelStyled = styled(GridCell)<{ isBonusCash: boolean; selected?: boolean }>(
  {
    fontSize: font.size.base.fontSize,
    lineHeight: 'normal',
    fontWeight: 'normal',
    textAlign: 'center',
    alignItems: 'center',
  },
  ({ isBonusCash, selected }) => ({
    color: isBonusCash ? (selected ? hexColors.white : hexColors.mariner) : undefined,
  })
)

export const AmountLabelStyled = styled(GridCell)<{ isBonusCash: boolean; selected?: boolean }>(
  {
    lineHeight: 'normal',
    textAlign: 'right',
    alignItems: 'center',
    flex: 0.5,
    justifyContent: 'end',
    marginRight: '0.25rem',
  },
  ({ isBonusCash, selected }) => ({
    color: selected ? colors.white : isBonusCash ? hexColors.mariner : colors.success[600],
  })
)

export const MoneyStyled = styled(Money)({
  fontSize: '1.2rem',
  fontWeight: 'bold',
})

export const BetsRemainingLabelStyled = styled('span')({
  backgroundColor: colors.neutral[200],
  color: colors.black,
  fontSize: font.size.base.fontSize,
  lineHeight: '1.1rem',
  borderRadius: radius.sm,
  padding: '0.4rem 1rem',
  display: 'flex',
})

export const BonusBetActionButtonsStyled = styled('div')({
  display: 'flex',
  gap: '1rem',
  marginBottom: '0.15rem',
  button: {
    width: '100%',
    height: '4rem',
  },
  'button:nth-of-type(2)': {
    color: '#4F792B',
    backgroundColor: 'transparent',
    borderColor: '#4F792B',
  },
})
